/* @generated */
import { Cluster as Cluster$1 } from "./cluster.esm.js";
import { Item } from "./item.esm.js";
const Cluster = Object.assign(Cluster$1, {
  /**
   * `Cluster.Item` is the required direct child of `Cluster` and is guaranteed to be a flex item.
   *
   * @public
   */
  Item
});
export {
  Cluster
};
